import type { JSX } from 'react';
import type { UseFormRegister, UseFormSetValue, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ExperienceDateFields } from './ExperienceDateFields';
import { EmploymentCheckboxes } from './EmploymentCheckboxes';

export interface ExperienceFormData {
  companyName: string;
  jobTitle: string;
  startYear: string;
  startMonth: string;
  endYear: string;
  endMonth: string;
  isOngoing: boolean;
  isFullTime: boolean;
  isContractor: boolean;
  continuous: boolean;
  isGig: boolean;
}

interface ExperienceFormFieldsProps {
  register: UseFormRegister<ExperienceFormData>;
  errors: FieldErrors<ExperienceFormData>;
  setValue: UseFormSetValue<ExperienceFormData>;
  isOngoing: boolean;
  isFullTime: boolean;
  isContractor: boolean;
  continuous: boolean;
  isGig: boolean;
}

export function ExperienceFormFields({
  register,
  errors,
  setValue,
  isOngoing,
  isFullTime,
  isContractor,
  continuous,
  isGig,
}: ExperienceFormFieldsProps): JSX.Element {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="companyName">Company Name *</Label>
        <Input
          id="companyName"
          {...register('companyName', { required: 'Company name is required' })}
          placeholder="Enter company name"
        />
        {errors.companyName && (
          <span className="text-sm text-destructive">{errors.companyName.message}</span>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="jobTitle">Job Title *</Label>
        <Input
          id="jobTitle"
          {...register('jobTitle', { required: 'Job title is required' })}
          placeholder="Enter job title"
        />
        {errors.jobTitle && (
          <span className="text-sm text-destructive">{errors.jobTitle.message}</span>
        )}
      </div>
      <ExperienceDateFields register={register} errors={errors} isOngoing={isOngoing} />
      <EmploymentCheckboxes
        setValue={setValue}
        isOngoing={isOngoing}
        isFullTime={isFullTime}
        isContractor={isContractor}
        continuous={continuous}
        isGig={isGig}
      />
    </>
  );
}
